var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserReload(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1645 8.70225C19.4445 7.10225 18.2345 5.78225 16.7045 4.93225C15.1745 4.08225 13.4045 3.76225 11.6745 4.00225C9.94451 4.24225 8.34451 5.04225 7.10451 6.27225L4.87451 8.37225V5.59225C4.87451 5.11225 4.48451 4.71225 3.99451 4.71225C3.50451 4.71225 3.12451 5.10225 3.12451 5.59225V10.3922C3.12451 10.4322 3.14451 10.4722 3.14451 10.5122C3.15451 10.5822 3.15451 10.6522 3.18451 10.7122C3.20451 10.7722 3.25451 10.8222 3.28451 10.8722C3.31451 10.9122 3.32451 10.9522 3.35451 10.9822C3.35451 10.9822 3.36451 10.9822 3.36451 10.9922C3.42451 11.0422 3.47451 11.0722 3.53451 11.1122C3.57451 11.1422 3.61451 11.1722 3.65451 11.1922C3.68451 11.2022 3.71451 11.2022 3.74451 11.2122C3.82451 11.2422 3.90451 11.2622 3.98451 11.2622H3.99451H8.79451C9.27451 11.2622 9.67451 10.8722 9.67451 10.3822C9.67451 9.90225 9.28451 9.51225 8.79451 9.51225H6.20451L8.30451 7.54225C8.31451 7.53225 8.32451 7.53225 8.33451 7.52225C9.30451 6.55225 10.5645 5.92225 11.9145 5.73225C13.2745 5.54225 14.6545 5.79225 15.8545 6.46225C17.0545 7.13225 18.0045 8.16225 18.5645 9.41225C19.1245 10.6622 19.2645 12.0622 18.9545 13.4022C18.6545 14.7422 17.9245 15.9422 16.8745 16.8322C15.8245 17.7222 14.5245 18.2422 13.1545 18.3222C11.7845 18.4022 10.4245 18.0322 9.28451 17.2722C8.14451 16.5122 7.27451 15.4022 6.82451 14.1122C6.66451 13.6522 6.16451 13.4122 5.70451 13.5822C5.26451 13.7222 5.02451 14.2222 5.18451 14.6822C5.76451 16.3322 6.86451 17.7522 8.32451 18.7222C9.78451 19.6922 11.5145 20.1622 13.2645 20.0622C15.0145 19.9622 16.6845 19.2922 18.0145 18.1622C19.3545 17.0322 20.2845 15.4922 20.6745 13.7922C21.0645 12.0822 20.8845 10.2922 20.1645 8.70225Z",
    fill: "url(#paint0_linear_3245_251524)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3245_251524",
    x1: 3.12451,
    y1: 12.0007,
    x2: 20.8759,
    y2: 12.0007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB6E19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#B47B23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#CDA243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121891,
    stopColor: "#E2C15B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171403,
    stopColor: "#F0D76D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.232867,
    stopColor: "#F9E477"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.306282,
    stopColor: "#FCE97B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39399,
    stopColor: "#F9E475"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504894,
    stopColor: "#EFD665"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635883,
    stopColor: "#E0C04B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#E8C853"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.808788,
    stopColor: "#FCE97B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#F8E475"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EED465"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#DDBB4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#C59826"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BA8916"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserReload);
export default __webpack_public_path__ + "static/media/User_Reload.e29fc8785da97287a3628cc364d24206.svg";
export { ForwardRef as ReactComponent };